export enum eTypeActionExternal{
    'Creación/Actualización de catalogo' = 1,
    'Creación de Inbound' = 2,
    'Creación de Outbound' = 3,
    'Ajuste de Stock' = 4
}

export enum eStatus{
    'Ejecutado' = 1,
    'Satisfactorio' = 2,
    'Con Error' = 3
}